module.exports = __webpack_public_path__ + "static/media/3.24c5e55e.jpg";